{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Editează atribut personalizat",
    "HEADER_BTN_TXT": "Adauga atributii personalizate",
    "LOADING": "Preluarea atributelor particularizate",
    "DESCRIPTION": "A custom attribute tracks additional details about your contacts or conversations—such as the subscription plan or the date of their first purchase. You can add different types of custom attributes, such as text, lists, or numbers, to capture the specific information you need.",
    "LEARN_MORE": "Learn more about custom attributes",
    "ATTRIBUTE_TYPES": {
      "TEXT": "Text",
      "NUMBER": "Număr",
      "LINK": "Link",
      "DATE": "Dată",
      "LIST": "Listă",
      "CHECKBOX": "Casetă de selectare",
      "TEXT_AREA": "Zonă de text"
    },
    "ADD": {
      "TITLE": "Adauga atributii personalizate",
      "SUBMIT": "Creeaza",
      "CANCEL_BUTTON_TEXT": "Renunță",
      "FORM": {
        "NAME": {
          "LABEL": "Nume afișat",
          "PLACEHOLDER": "Introducerea numelui afișat al atributului personalizat",
          "ERROR": "Numele este obligatoriu"
        },
        "DESC": {
          "LABEL": "Descriere",
          "PLACEHOLDER": "Introduceți descrierea atributului personalizat",
          "ERROR": "Descrierea este obligatorie"
        },
        "MODEL": {
          "LABEL": "Aplică la",
          "PLACEHOLDER": "Vă rugăm să selectaţi un tip",
          "ERROR": "Conținutul este obligatoriu"
        },
        "TYPE": {
          "LABEL": "Tip",
          "PLACEHOLDER": "Vă rugăm să selectaţi un tip",
          "ERROR": "Tipul de agent este obligatoriu",
          "LIST": {
            "LABEL": "Valori listă",
            "PLACEHOLDER": "Vă rugăm să introduceţi valoarea şi apăsaţi tasta enter",
            "ERROR": "Trebuie să conțină cel puțin o valoare"
          }
        },
        "KEY": {
          "LABEL": "Cheie",
          "PLACEHOLDER": "Introduceți cheia atributului personalizat",
          "ERROR": "Cheia este obligatorie",
          "IN_VALID": "Cheie invalidă"
        },
        "REGEX_PATTERN": {
          "LABEL": "Regex Pattern",
          "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
        },
        "REGEX_CUE": {
          "LABEL": "Regex Cue",
          "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Enable regex validation"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Atribut personalizat adăugat cu succes!",
        "ERROR_MESSAGE": "Nu s-a putut crea un atribut particularizat. Încercați din nou mai târziu."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Şterge",
      "API": {
        "SUCCESS_MESSAGE": "Atribut personalizat șters cu succes.",
        "ERROR_MESSAGE": "Nu s-a putut șterge atributul personalizat. Încercați din nou."
      },
      "CONFIRM": {
        "TITLE": "Sunteți sigur că doriți să ștergeți - {attributeName}",
        "PLACE_HOLDER": "Te rugăm să introduci {attributeName} pentru a confirma",
        "MESSAGE": "Ștergerea va elimina atributul personalizat",
        "YES": "Şterge ",
        "NO": "Renunță"
      }
    },
    "EDIT": {
      "TITLE": "Editează atribut personalizat",
      "UPDATE_BUTTON_TEXT": "Actualizare",
      "TYPE": {
        "LIST": {
          "LABEL": "Valori listă",
          "PLACEHOLDER": "Vă rugăm să introduceţi valoarea şi apăsaţi tasta enter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Atribut personalizat actualizat cu succes",
        "ERROR_MESSAGE": "A apărut o eroare la actualizarea atributului personalizat, vă rugăm să încercați din nou"
      }
    },
    "TABS": {
      "HEADER": "Editează atribut personalizat",
      "CONVERSATION": "Conversație",
      "CONTACT": "Contact"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nume",
        "DESCRIPTION": "Descriere",
        "TYPE": "Tip",
        "KEY": "Cheie"
      },
      "BUTTONS": {
        "EDIT": "Editare",
        "DELETE": "Şterge"
      },
      "EMPTY_RESULT": {
        "404": "Nu exista atribute personalizate create",
        "NOT_FOUND": "Nu sunt configurate atribute personalizate"
      },
      "REGEX_PATTERN": {
        "LABEL": "Regex Pattern",
        "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
      },
      "REGEX_CUE": {
        "LABEL": "Regex Cue",
        "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Enable regex validation"
      }
    }
  }
}
